<app-navbar></app-navbar>

  <div class="page">
    <div class="confirmation-container" [ngClass]="screenSize.isTablet ? 'px-2' : ''">
      <ng-container *ngIf="!wentWrong; else verifyError">
        <app-phone-number-verification-text audience="clinic" [isVerified]="isVerified" [number]="phoneNumber"></app-phone-number-verification-text>
      </ng-container>
      <ng-template #verifyError>
        <span class="material-symbols-outlined text-danger" style="font-size: 64px;">error</span>
        <h3 class="mb-0">{{ 'verification.title-failed' | translate }}</h3>
        <p class="lead mb-0">{{ 'verification.message-failed' | translate }}</p>
      </ng-template>
      <button class="dashboard-btn" (click)="toDashboard()">{{ 'Return to Home' | translate }}</button>
    </div>
  </div>